import {
  Box,
  Button,
  HStack,
  Input,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import {
  createPersonalInterview,
  getPersonalInterviewData,
} from "API/personalInterviewApi";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useHistory } from "react-router-dom";

const EditAreaOfExpertise = ({ tab, setTab, user: currUser }) => {
  const toast = useToast();
  const history = useHistory();
  const [areaOfExpertiseLabels, setAreaOfExpertiseLabels] = useState([
    {
      label: "Population of State /District / Taluka / Village",
      values: "",
      new: false,
    },
    { label: "Geographical importance", values: "", new: false },
    { label: "Historical importance", values: "", new: false },
    { label: "Major trade commerce & Industry", values: "", new: false },
    { label: "State Budget / deficit", values: "", new: false },
    { label: "Seasons", values: "", new: false },
    { label: "Crop", values: "", new: false },
    { label: "Detail, positions, qualification", values: "", new: false },
    { label: "Nature of job", values: "", new: false },
    { label: "Growth in Job", values: "", new: false },
    {
      label: "Basic information of the industry working",
      values: "",
      new: false,
    },
    { label: "Home maker / working", values: "", new: false },
    { label: "Nature of work", values: "", new: false },
    { label: "Growth in profession", values: "", new: false },
    { label: "Earnings", values: "", new: false },
  ]);

  const createPersonalInterviewMutation = useMutation(createPersonalInterview);
  // const { user } = useAppSelector((state) => state.auth);
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(currUser);
  }, [currUser]);

  const { data: personalInterviewData } = useQuery(
    ["personalInterview"],
    () => getPersonalInterviewData(user),
    {
      enabled: !!user,
    }
  );

  useEffect(() => {
    if (
      personalInterviewData?.data?.areaOfExpertise &&
      personalInterviewData?.data?.areaOfExpertise.length !== 0
    ) {
      const newFields = [];
      personalInterviewData?.data?.areaOfExpertise.map((field) =>
        newFields.push({
          label: field.label,
          values: field.values,
          new: false,
        })
      );
      setAreaOfExpertiseLabels(newFields);
    }
  }, [personalInterviewData]);

  const handleInputChange = (e, index) => {
    const newFields = [...areaOfExpertiseLabels];
    newFields[index].values = e.target.value;
    setAreaOfExpertiseLabels(newFields);
  };

  const handleNewInputLabelChange = (e, index) => {
    const newFields = [...areaOfExpertiseLabels];
    newFields[index].label = e.target.value;
    setAreaOfExpertiseLabels(newFields);
  };

  const handleInsertField = (index) => {
    const newFields = [...areaOfExpertiseLabels];
    newFields.splice(index + 1, 0, { label: "", values: "", new: true });
    setAreaOfExpertiseLabels(newFields);
  };

  const handleRemoveInputField = (index) => {
    const newFields = [...areaOfExpertiseLabels];
    newFields.splice(index, 1);
    setAreaOfExpertiseLabels(newFields);
  };

  const handleSaveClick = async ({ next }) => {
    const data = [];
    areaOfExpertiseLabels.map((field, index) => {
      if (field.label !== "") {
        data.push({
          label: field.label,
          values: field.values === "" ? "N / A" : field.values,
          order: index,
        });
      }
      return "";
    });
    let response = await createPersonalInterviewMutation.mutateAsync({
      data,
      type: "areaOfExpertise",
      user,
    });
    if (response.success) {
      toast({
        title: response.message,
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      if (next) setTab(tab + 1);
    }
  };

  return (
    <>
      <VStack w={"100%"} px={4}>
        {areaOfExpertiseLabels.map((key, index) =>
          !key.new ? (
            <Box w={"100%"} key={index}>
              <Text>{key.label}</Text>
              <HStack>
                <Input
                  onChange={(e) => handleInputChange(e, index)}
                  value={key.values}
                ></Input>
                <Button
                  colorScheme="teal"
                  fontSize={"xl"}
                  onClick={() => handleInsertField(index)}
                >
                  +
                </Button>
              </HStack>
            </Box>
          ) : (
            <Box w={"100%"} key={index}>
              {/* <HStack my={"16px"}>
                <Input value={"Field Label"} readOnly></Input>
                <Input value="Field Value" readOnly></Input>
                <Button
                  colorScheme="red"
                  onClick={() => handleRemoveInputField(index)}
                >
                  -
                </Button>
              </HStack> */}
              <HStack>
                <Input
                  placeholder="Field Label"
                  value={key.label}
                  onChange={(e) => handleNewInputLabelChange(e, index)}
                ></Input>
                <Input
                  placeholder="Field Value"
                  onChange={(e) => handleInputChange(e, index)}
                  value={key.values}
                ></Input>
                <Button
                  colorScheme="red"
                  onClick={() => handleRemoveInputField(index)}
                >
                  -
                </Button>
              </HStack>
            </Box>
          )
        )}
      </VStack>
      <HStack w="100%" px={4} py={"30px"}>
        <Button
          colorScheme="teal"
          onClick={() => handleSaveClick({ next: false })}
        >
          Save
        </Button>
        <Button colorScheme="teal" onClick={() => setTab(tab - 1)}>
          Previous
        </Button>
        <Button
          colorScheme="teal"
          onClick={() => handleSaveClick({ next: true })}
        >
          Save & Next
        </Button>
        <Button
          bg={"grey"}
          color={"White"}
          onClick={() =>
            history.push({
              pathname: "/interview",
              state: { item: user },
            })
          }
        >
          Cancel
        </Button>
      </HStack>
    </>
  );
};

export default EditAreaOfExpertise;
